import React, { useState } from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import ButtonBase from '@material-ui/core/ButtonBase';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { Paper } from '@material-ui/core';
import ChartIcon from 'components/SurveyResult/images/chart.svg';
import TrendsWrapper from './Trends/TrendsWrapper';

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: 16,
  },
  label: {
    ...theme.typography.body2,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    width: 420,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  container: {
    padding: '45px 30px 30px 30px',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    padding: 6,
  },
  chartIcon: {
    marginLeft: 5,
    height: 20,
    width: 20,
  },
}));

const GaugeAboutButtonWithModal = ({
  component,
  assessment,
  slug,
  sortedIntervals,
  displayIntervals,
  scale,
  track,
}) => {
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleClick = () => {
    setOpen(true);

    track('Assessment Results - View Your Results History Clicked');
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <ButtonBase
        disableRipple
        onClick={handleClick}
        className={classes.button}
      >
        <Typography className={classes.label} gutterBottom>
          {_get(
            assessmentResultsSiteCopy,
            'pageCopy.variantBScoreHistoryLabel',
          )}
          <img src={ChartIcon} alt="Chart" className={classes.chartIcon} />
        </Typography>
      </ButtonBase>
      <Modal open={open} keepMounted onClose={handleClose}>
        <Box className={classes.wrapper}>
          <Paper className={classes.container}>
            <ButtonBase
              onClick={handleClose}
              className={classes.closeButton}
              aria-label="Close"
            >
              <CloseIcon />
            </ButtonBase>
            <Grid container spacing={2}>
              <TrendsWrapper
                type="overall"
                component={component}
                assessment={assessment}
                slug={slug}
                sortedIntervals={sortedIntervals}
                displayIntervals={displayIntervals}
                scale={scale}
              />
            </Grid>
          </Paper>
        </Box>
      </Modal>
    </>
  );
};

export default GaugeAboutButtonWithModal;
